import { Expose } from "class-transformer";

export class UpdateCurrencyDto {
  @Expose()
  id: string;

  @Expose()
  isoCode: string;

  @Expose()
  label: string;

  @Expose()
  exchangeRate: number;

  @Expose()
  isDefault?: boolean;
}
